/**
 * Created by Carsten Bühler
 * User: c.buehler on 04.10.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import ReactDOM from 'external/react-dom';
import PropTypes from 'external/prop-types';
import { Button, FormCheck, FormGroup, ListGroup } from 'external/react-bootstrap';
import { DataUtil, ValidationMessage } from 'plugin/liferay-widgets-react-web';

const Multiselect = ({ layers, baseLayer, defaultId, onSelectDefault, onSelect }) => {
    const selected = baseLayer.reduce((p, c) => (p[c.id] = true) && p, {});
    return (
        <ListGroup as="ul">{
            layers.map(l => (
                <ListGroup.Item as="li" key={'BaseLayerSelect_' + l.id} className="d-flex align-items-center justify-content-between">
                    <FormCheck checked={!!selected[l.id]} onChange={() => onSelect(l)}/>
                    
                    <span>{l.title}</span>
                    
                    {
                        defaultId === l.id ?
                        <span className="title"><strong>Standard</strong></span> :
                        <Button variant="primary" onClick={() => onSelectDefault(l)}>Als Standard</Button>
                    }
                </ListGroup.Item>
            ))
        }
        </ListGroup>
    );
};

Multiselect.propTypes = {
    layers: PropTypes.array,
    baseLayer: PropTypes.array,
    defaultId: PropTypes.number,
    onSelectDefault: PropTypes.func,
    onSelect: PropTypes.func
};

class MapConfigBaseLayerSelection extends React.Component {

    onBaseLayerChange(layers, mapConfig){
        const select = ReactDOM.findDOMNode(this.refs.baseLayerSelect);

        let baseLayerIds = select && select.selectedOptions ? Array.prototype.map.call(select.selectedOptions, function (o){
            return o.value;
        }) : undefined;
        let baseLayer = [];

        layers.forEach(layer => {
            baseLayerIds.forEach(id => {
                if (layer.id == id) {
                    baseLayer.push(layer);
                }
            });
        });

        this.props.onChange({
            ...mapConfig,
            baseLayer
        });
    }

    onSelect(layer){
        const mapConfig = DataUtil.asItem(this.props.mapConfig),
            { baseLayer = [] } = mapConfig,
            filter = baseLayer.filter(l => l.id !== layer.id);

        if (mapConfig.defaultBaseLayerId === layer.id) {
            delete mapConfig.defaultBaseLayerId;
        }

        this.props.onChange({
            ...mapConfig,
            baseLayer: filter.length !== baseLayer.length ? filter : baseLayer.concat(layer)
        });
    }

    onSelectDefault(layer){
        const mapConfig = DataUtil.asItem(this.props.mapConfig),
            { baseLayer = [] } = mapConfig,
            filter = baseLayer.filter(l => l.id !== layer.id);
        this.props.onChange({
            ...mapConfig,
            defaultBaseLayerId: layer.id,
            baseLayer: filter.concat(layer)
        });
    }

    handleChange(data){
        this.props.onChange({
            ...data
        });
    }

    shouldComponentUpdate(nextProps, nextState){
        const { defaultBaseLayerId, baseLayer } = DataUtil.asItem(this.props.mapConfig);
        const { nextDefaultBaseLayerId, nextBaseLayer } = DataUtil.asItem(nextProps.mapConfig);
        return this.props.layers !== nextProps.layers ||
            defaultBaseLayerId !== nextDefaultBaseLayerId ||
            baseLayer !== nextBaseLayer ||
            this.props.formValidation['defaultBaseLayer'] !== nextProps.formValidation['defaultBaseLayer'] ||
            this.props.formValidation['baseLayer'] !== nextProps.formValidation['baseLayer'];
    }

    render(){
        const layers = DataUtil.asArray(this.props.layers) || [],
            { defaultBaseLayerId, baseLayer = [] } = DataUtil.asItem(this.props.mapConfig),
            formValidation = this.props.formValidation;

        return (<React.Fragment>
            <ValidationMessage formValidation={formValidation} propName="defaultBaseLayer"/><br/>
            <ValidationMessage formValidation={formValidation} propName="baseLayer"/>
            <FormGroup controlId="formControlsSelectMultiple">
                <Multiselect layers={layers}
                             baseLayer={baseLayer}
                             defaultId={defaultBaseLayerId}
                             onSelectDefault={this.onSelectDefault.bind(this)}
                             onSelect={this.onSelect.bind(this)}/>

            </FormGroup>
            <ValidationMessage formValidation={formValidation} propName="defaultBaseLayer"/><br/>
            <ValidationMessage formValidation={formValidation} propName="baseLayer"/>
        </React.Fragment>);

    }
}

MapConfigBaseLayerSelection.propTypes = {
    formValidation: PropTypes.object,
    layers: PropTypes.object,
    mapConfig: PropTypes.object,
    onChange: PropTypes.func
};

export default MapConfigBaseLayerSelection;




// WEBPACK FOOTER //
// ./js/components/MapConfigBaseLayerSelection.jsx